export default __webpack_public_path__ + "static/media/milheto.82f83f34.png";